<template>
  <div v-show="visible" class="modal">
    <div class="modal-body">
      <div class="modal-body__btn-close has-link" @click="close"></div>
      <p class="modal-title">브라우저 지원 종료 안내</p>
      <div class="modal-contents">
        <img :src="assetPath" alt="Logo of ie" />
        <p>Internet Explorer 브라우저에 대한 지원이<br />2021년 4월 21일에 종료됩니다.</p>
      </div>
      <p class="modal-desc">패스트캠퍼스를 계속 이용하려면 지원되는 브라우저로 전환해야 합니다.</p>
      <div class="modal-btns">
        <button @click="goBrowserLinkPage">다운로드 받으러 가기</button>
      </div>
    </div>
  </div>
</template>
<script>
import { isDesktop, isIe } from '@fastcampus/browser-util';

const IS_IE_DEPRECATED_MODAL_CHECKED = 'IS_IE_DEPRECATED_MODAL_CHECKED';

export default {
  name: 'modal-stop-ie',
  props: ['env', 'assetPath'],
  data() {
    return {
      visible: false,
    };
  },
  created() {
    if (isDesktop && isIe && !this.getDontShowChecked()) {
      this.visible = true;
    } else {
      this.visible = false;
    }
  },
  methods: {
    close() {
      if (!this.getDontShowChecked()) {
        this.setDontShow();
      }
      this.visible = false;
    },
    getDontShowChecked() {
      return window.sessionStorage.getItem(IS_IE_DEPRECATED_MODAL_CHECKED);
    },
    setDontShow() {
      window.sessionStorage.setItem(IS_IE_DEPRECATED_MODAL_CHECKED, true);
    },
    goBrowserLinkPage() {
      window.open('/info/browsers');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: rgba(#000, 0.8);

  color: #000;

  &-body {
    position: relative;
    width: 54rem;
    min-height: 38.2rem;
    margin: 0 2rem;
    border-radius: 0.6rem;
    background-color: white;
    box-shadow: 0 1.6rem 4.8rem rgba(0, 0, 0, 0.22);
    font-weight: 700;
    color: #2e2e2e;
    &__btn-close {
      position: absolute;
      top: 2.3rem;
      right: 2.3rem;

      width: 2rem;
      height: 2rem;

      background: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='2.21973' y='3.63416' width='2' height='20' rx='1' transform='rotate(-45 2.21973 3.63416)' fill='%23AAAAAF'/%3E%3Crect x='16.3618' y='2.21997' width='2' height='20' rx='1' transform='rotate(45 16.3618 2.21997)' fill='%23AAAAAF'/%3E%3C/svg%3E%0A")
        no-repeat;
    }
  }
  &-title {
    padding-top: 6.5rem;
    padding-bottom: 2.5rem;
    font-size: 2.2rem;
    text-align: center;
  }
  &-contents {
    display: flex;
    justify-content: center;
    padding: 3rem 0;
    background-color: #f2f2f2;
    font-size: 1.6rem;
    color: #171717;
    img {
      width: 4.8rem;
      height: 4.8rem;
      padding-top: 0.3rem;
      padding-right: 2rem;
    }
    p {
      line-height: 2.6rem;
    }
  }
  &-desc {
    padding: 3.2rem 1rem 0;
    font-weight: 400;
    font-size: 1.4rem;
    text-align: center;
  }
  &-btns {
    padding-top: 3.2rem;
    padding-bottom: 3.2rem;
    text-align: center;
    button {
      width: 23.6rem;
      height: 4.8rem;
      border-radius: 0.4rem;
      background-color: #ed234b;
      font-weight: 700;
      font-size: 1.6rem;
      color: white;
      line-height: 4rem;
    }
  }
}
</style>
